import { useContext } from "react";

import { AuthContext } from "components/AuthProvider/AuthProvider";
import { useSessionTypes } from "hooks/useSessionTypes";
import { useSingleSessionPrices } from "hooks/useSingleSessionPrices";
import { useAccountStatus } from "hooks/useAccountStatus";

export const useSessionTypesAndPrices = (
	mentorId?: string,
	omitSessionTypesWithNoActivePrices?: false
) => {
	const [{ isSignedIn, uid, haveSignInStatus }] = useContext(AuthContext);

	const { _populated: haveAccountStatus } = useAccountStatus();

	const {
		isWaiting: sessionTypesWaiting,
		isLoading: sessionTypesLoading,
		isError: sessionTypesError,
		output: sessionTypesOutput
	} = useSessionTypes({
		mentorId,
		doWait:
			!haveSignInStatus ||
			(haveSignInStatus && isSignedIn && !haveAccountStatus)
	});

	const {
		isWaiting: singleSessionPricesWaiting,
		isLoading: singleSessionPricesLoading,
		isError: singleSessionPricesError,
		output: singleSessionPricesOutput
	} = useSingleSessionPrices({
		mentorId,
		sessionTypeIds: sessionTypesOutput
			? sessionTypesOutput.page.map(entry => entry.id)
			: [],
		includePricesForGuestUid: uid,
		doWait:
			!haveSignInStatus ||
			(haveSignInStatus && isSignedIn && !haveAccountStatus)
	});

	const sessionTypes = sessionTypesOutput
		? omitSessionTypesWithNoActivePrices
			? sessionTypesOutput.page.filter(
					sessionType =>
						singleSessionPricesOutput &&
						singleSessionPricesOutput.page.some(
							singleSessionPrice =>
								singleSessionPrice.sessionTypeId === sessionType.id
						)
			  )
			: sessionTypesOutput.page
		: [];
	const singleSessionPrices = singleSessionPricesOutput
		? singleSessionPricesOutput.page
		: [];

	return {
		isWaiting: sessionTypesWaiting || singleSessionPricesWaiting,
		isLoading: sessionTypesLoading || singleSessionPricesLoading,
		isError: sessionTypesError || singleSessionPricesError,
		output: {
			sessionTypes,
			singleSessionPrices
		}
	};
};
